import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { KEY_FACTS, STAGES, SHOW_ESTATE, fadeUp } from './data';

export const KeyFacts = () => {
  const options = SHOW_ESTATE ? STAGES : STAGES.slice(0, 1);
  return (
    <section className="bg-[#1a1e1a] pb-16 md:pb-20" data-testid="key-facts-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.dl {...fadeUp} className="grid grid-cols-2 md:grid-cols-5 border-y border-white/15">
          {KEY_FACTS.map((f, i) => (
            <div key={f.label} className="py-6 md:py-8 px-2 md:px-6 border-white/15 md:border-l first:md:border-l-0" data-testid={`key-fact-${i}`}>
              <dt className="text-[#d6cdb4] text-xs tracking-[0.15em] uppercase mb-2">{f.label}</dt>
              <dd className="text-white text-lg md:text-xl font-light">{f.value}</dd>
            </div>
          ))}
        </motion.dl>
        <motion.div {...fadeUp} className="mt-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="text-white/75 text-sm md:text-base">
            {options.map((s) => `${s.name} — ${s.price}`).join(' · ')}
            <span className="text-white/60"> · Facts per architectural plans; confirm details with the agent.</span>
          </p>
          <a href="#options" className="inline-flex items-center gap-2 text-[#d6cdb4] text-sm tracking-[0.12em] uppercase hover:text-white transition-colors" data-testid="key-facts-options-link">
            What's included <ArrowRight size={14} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
